// MAIN VARIABLES
const NODE_ENV = 'production' // Uncomment this line for PROD 
// const NODE_ENV = 'local' // Uncomment this line when testing in LOCAL

const PROD_URL = 'https://adjudicamap.mynookapp.es/backend/index.php?endpoint=' 
const LOCAL_URL = 'http://localhost:5001/api/'

const BASE_URL = NODE_ENV === 'production' ? PROD_URL : LOCAL_URL;

export { BASE_URL };
